var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49137 10.9687L12.0013 8.45982L14.5123 10.9707L15.972 9.51012L12.0013 5.53857L8.0307 9.5091L9.49137 10.9687ZM5.53857 12.0003L6.99871 10.5402L8.45884 12.0003L6.99871 13.4604L5.53857 12.0003ZM12.0013 15.5414L9.49137 13.0315L8.02866 14.4901L8.0307 14.4922L12.0013 18.4617L15.972 14.4901L15.973 14.4891L14.5123 13.0305L12.0013 15.5414ZM15.5414 12.0007L17.0015 10.5406L18.4616 12.0007L17.0015 13.4608L15.5414 12.0007ZM12.0013 10.5175L13.4824 11.9996H13.4834L13.4824 12.0006L12.0013 13.4827L10.5203 12.0027L10.5182 11.9996L10.5203 11.9976L10.7795 11.7383L10.9061 11.6128L12.0013 10.5175Z",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.dfa262f3.svg";
export { ForwardRef as ReactComponent };